<template>
    <div class="vue-month-selector-component">
        <div class="vue-month-selector-dialog"> 
            <div class="vue-month-selector-dialog-header" :style="{background: color,border: '1px solid'+ color}">
                <div @click.prevent="changeYearBySign(-1)" class="vue-month-selector-arrow-container">
                    <div class="vue-month-selector-arrow-left"></div>
                </div>
                <div class="vue-month-selector-current-year" @click="viewYearPickerDialog">
                    {{ tmp.year }}
                </div>
                <div @click.prevent="changeYearBySign(1)" class="vue-month-selector-arrow-container">
                    <div class="vue-month-selector-arrow-right"></div>
                </div>
            </div>
            <div class="vue-month-selector-dialog-content" v-if="ui.viewMonthPicker" ref="vueMonthSelectorContent">
                <div v-for="(month, monthNumber) in months" :key="monthNumber" class="vue-month-selector-month-item" @click="selectMonth(monthNumber)" v-bind:class="{ 'vue-month-selector-active': isActiveMonth(monthNumber) }">
                    {{ month }}
                </div>
            </div>
            <div v-else class="vue-month-selector-dialog-content vue-month-selector-dialog-content-year-picker" ref="vueMonthSelectorYearList" v-bind:style="{'max-height': ui.dialogContentHeight + 'px'}">
                <div v-for="year in getYearList()" v-bind:class="{'vue-month-selector-active': year.current === true}" @click="selectYear(year.year)">
                    {{ year.year }}
                </div>
            </div>
        </div>
    </div>
</template>
<style>
   

    .vue-month-selector-component {
        font-size: 14px;
    }
    .vue-month-selector-dialog-header {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        background: #4a8ef5;
        color: #FFF;
        border: 1px solid #498df5;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom: none;
        font-weight: 500;
        align-items: center;
    }
    .vue-month-selector-arrow-container {
        padding: 5px;
        cursor: pointer;
    }
    .vue-month-selector-arrow-left, .vue-month-selector-arrow-right {
        width: 0;
        height: 0;
        border: 8px solid transparent;
    }
    .vue-month-selector-arrow-left {
        border-right-color: #FFF;
        border-left: 0;
    }
    .vue-month-selector-current-year {
        text-align: center;
        cursor: pointer;
    }
    .vue-month-selector-arrow-right {
        border-left-color: #FFF;
        border-right: 0;
    }
    .vue-month-selector-dialog {
        width: 250px;
        overflow: hidden;
        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.22);
        border-radius: 5px;
    }
    .vue-month-selector-dialog-content {
        display: flex;
        flex-wrap: wrap;
        background: #FFF;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid #d6d6d6;
        border-top: none;
    }
    .vue-month-selector-dialog-content-year-picker {
        display: block;
        text-align: center;
        height: 100%;
        overflow-y: scroll;
    }
    .vue-month-selector-dialog-content-year-picker div {
        padding: 10px 0;
        font-size: 16px;
        cursor: pointer;
    }
    .vue-month-selector-month-item {
        width: 33.3333%;
        padding: 15px;
        box-sizing: border-box;
        text-align: center;
        cursor: pointer;
    }
    .vue-month-selector-active {
        background: #ebeff5;
    }
</style>
<script>
    import props from './props.js';
    import MonthNameHelper from './utils/MonthNameHelper';
    import MonthNormalizer from "./utils/MonthNormalizer";

    export default {
        props: props,
        data() {
            return {
                tmp: {
                    year: null
                },
                ui: {
                    dialogContentHeight: 0,
                    viewMonthPicker: true
                }
            }
        },
        created() {
            MonthNormalizer.normalize(this.value);
            this.changeYear(this.value.year);
            this.changeMonth(this.value.month);
        },
        methods: {
            changeYearBySign(sign) {
               this.changeYear(this.tmp.year + sign);
            },
            changeYear(year) {
                this.tmp.year = year;
            },
            changeMonth(monthNumber) {
                this.value.month = monthNumber;
                this.value.year = this.tmp.year;
            },
            selectMonth(monthNumber) {
                this.changeMonth(monthNumber);
                this.$emit('input', this.value);
                this.$emit('change-month-name', MonthNameHelper.getMonthName(this.months, this.value));
                this.$emit('change', this.value);
            },
            viewYearPickerDialog() {
                if (this.ui.viewMonthPicker === false) {
                    this.ui.viewMonthPicker = true;
                    return;
                }
                this.ui.viewMonthPicker = false;
                this.$nextTick(() => {
                    let $activeYearElement = this.$refs.vueMonthSelectorYearList.querySelector('.vue-month-selector-active');
                    if ($activeYearElement !== undefined) {
                        this.$refs.vueMonthSelectorYearList.scrollTop = $activeYearElement.offsetTop - 100;
                    }
                });
            },
            isActiveMonth(monthNumber) {
                return this.value.month === monthNumber && this.tmp.year === this.value.year;
            },
            getYearList() {
                let years = [];
                for (let i = 100; i >= -100; i--) {
                    let year = this.tmp.year + i;
                    years.push({
                        year: year,
                        current: year === this.tmp.year
                    })
                }
                return years;
            },
            selectYear(year) {
                this.changeYear(year);
                this.ui.viewMonthPicker = true;
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.ui.dialogContentHeight = this.$refs.vueMonthSelectorContent.offsetHeight;
            });
        },
    }
</script>